export const locale = {
    lang: 'ro',
    data: {
        'AUTHENTIFICATION': {
            'TITLE': 'Autentificare'
        }
    }
};
